import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { RestfullApiService, RestfullApiServiceGet } from "../config/service";
import { useNavigate } from "react-router-dom";
import { encryptData } from "../utils/storage";
import {
  Link,
  TextField,
  Tooltip,
  tooltipClasses,
  useMediaQuery,
} from "@mui/material";
import { useSelector } from "react-redux";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { styled, useTheme } from "@mui/material/styles";
import Select from "react-select";

import dayjs from "dayjs";
import DivLoader from "../utils/DivLoader";
import { selectCustomStyle } from "../utils/selectCustomStyle";
import { LightTooltip } from "../utils/Tooltip";
import { removeSpace } from "../utils";

const Booking = () => {
  const [bookingData, setBookingData] = useState([]);
  const [date, setDate] = useState(dayjs());
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("All");
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
  const user = useSelector((state) => state.user.userProfile);
  const navigate = useNavigate();

  const booking_time = [
    { label: "All Booking", value: "AllBooking" },
    { label: "Upcoming", value: "Upcoming" },
    { label: "Pending", value: "Pending" },
    { label: "Completed", value: "Completed" },
  ];
  const [selectedBooking, setSelectedBooking] = useState({
    label: "All Booking",
    value: "AllBooking",
  });

  const downloadInvoice = async (booking_id) => {
    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
    };

    try {
      const result = await RestfullApiServiceGet(
        reqdata,
        `participant/downloadinvoice?Booking_Id=${booking_id}`
      );

      if (result) {
        const base64PDF = result.data; // assuming result.data contains the base64 string
        // debugger;
        // Decode base64 string to binary string
        const binaryString = atob(base64PDF);

        // Convert binary string to Uint8Array
        const arrayBuffer = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          arrayBuffer[i] = binaryString.charCodeAt(i);
        }

        // Create Blob from Uint8Array
        const blob = new Blob([arrayBuffer], { type: "application/pdf" });

        // Create URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a link element, set the href and download attributes
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `invoice_${booking_id}.pdf`);

        // Append the link to the DOM and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up: remove the link from the DOM
        document.body.removeChild(link);

        // Optionally, handle success messages
        toast.dismiss("Downloading...");
        toast.success("Invoice downloaded successfully!");
      }
    } catch (err) {
      // Handle errors if the API call fails
      toast.error("Failed to download invoice. Please try again later.");
      console.error("Error downloading invoice:", err);
    }
  };
  async function bookingDataHandle(Event_Id, methodName, filterDate = null) {
    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Method_Name: methodName,
      Filter: "",
      // Filter: filterDate
      //   ? dayjs(filterDate).format("YYYY-MM-DD")
      //   : dayjs().format("YYYY-MM-DD"),
    };

    console.log("Request Data:", reqdata);

    try {
      setLoading(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/Profile_get"
      );
      console.log("API Response:", result);

      if (result?.data?.Result?.Table1[0]?.Result_Id === -1) {
        toast.error(result?.data?.Result?.Table1[0]?.Result_Description);
        return;
      }
      if (result) {
        setBookingData(result?.data?.Result.Table1);

        return result;
      }
    } catch (err) {
      console.error("API Error:", err);
      alert(err);
      toast.error(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    bookingDataHandle("", "AllBooking", date);
  }, []);

  const handleTabClick = (filterValue) => {
    setActiveTab(filterValue);
  };

  console.log(bookingData);

  const navigateToEvent = (nav, displayName) => {
    navigate(`/event-details/${removeSpace(displayName)}/${nav}`);
  };

  return (
    <>
      {/* <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
        <div className="col-auto">
          <h1 className="text-20 lh-14 fw-600">My Bookings</h1>
        </div>
        <div className="col-auto"></div>
      </div> */}

      <div className="py-30 px-30 lg:py-10 lg:px-10 rounded-16 bg-white shadow-2">
        <div className="tabs -underline-2 js-tabs">
          {matchesSM ? (
            <div className="lg:d-block">
              <Select
                placeholder="Select Booking"
                styles={selectCustomStyle}
                onChange={(e) => {
                  setSelectedBooking(e);
                  bookingDataHandle("", e?.value, date);
                }}
                isSearchable={false}
                options={booking_time}
                value={selectedBooking}
              />
            </div>
          ) : (
            <></>
          )}
          <div className="tabs__controls row x-gap-40 py-5 y-gap-10 lg:x-gap-20 js-tabs-controls relative lg:d-none">
            <div onClick={() => handleTabClick("All")} className="col-auto">
              <button
                onClick={() => bookingDataHandle("", "AllBooking", date)}
                className={`tabs__button text-15 lg:text-14 text-light-1 fw-600 pb-5 lg:pb-0 js-tabs-button ${
                  activeTab === "All" ? "is-tab-el-active" : ""
                }`}
                data-tab-target=".-tab-item-1"
              >
                All Booking
              </button>
            </div>
            <div
              onClick={() => handleTabClick("Upcoming")}
              className="col-auto"
            >
              <button
                onClick={() => bookingDataHandle("", "Upcoming", date)}
                className={`tabs__button text-15 lg:text-14 text-light-1 fw-600 pb-5 lg:pb-0 js-tabs-button ${
                  activeTab === "Upcoming" ? "is-tab-el-active" : ""
                }`}
                data-tab-target=".-tab-item-2"
              >
                Upcoming
              </button>
            </div>
            <div onClick={() => handleTabClick("Pending")} className="col-auto">
              <button
                onClick={() => bookingDataHandle("", "Pending", date)}
                className={`tabs__button text-15 lg:text-14 text-light-1 fw-600 pb-5 lg:pb-0 js-tabs-button ${
                  activeTab === "Pending" ? "is-tab-el-active" : ""
                }`}
                data-tab-target=".-tab-item-3"
              >
                Pending
              </button>
            </div>
            <div
              onClick={() => handleTabClick("Completed")}
              className="col-auto"
            >
              <button
                onClick={() => bookingDataHandle("", "Completed", date)}
                className={`tabs__button text-15 lg:text-14 text-light-1 fw-600 pb-5 lg:pb-0 js-tabs-button ${
                  activeTab === "Completed" ? "is-tab-el-active" : ""
                }`}
                data-tab-target=".-tab-item-4"
              >
                Completed
              </button>
            </div>
            {/* <div className="col-auto absolute top-0 right-0">
              <div className="lg:justify-start mt-10">
                <div className="single-field y-gap-20">
                  <div className="form-control">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      className="form-control"
                      name="date"
                      format="DD/MM/YYYY"
                      inputFormat="DD/MM/YYYY"
                      disableFuture
                      value={date}
                      onChange={handleDateChange}
                      open={open}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            fontFamily: "Montserrat, sans-serif !important",
                            "& .MuiButtonBase-root": {
                              color: "orange",
                            },
                          }}
                          fullWidth
                          className="form-control"
                        />
                      )}
                      slotProps={{
                        inputAdornment: {
                          position: "end",
                        },
                        textField: {
                          onClick: () => setOpen(true),
                        },
                        openPickerIcon: {
                          sx: {
                            color: "#f05736",
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </div>
                {error && <div className="text-error-2 text-13">{error}</div>}
                </div>
              </div>
            </div> */}
          </div>
          <div className="row tabs__content pt-30 js-tabs-content">
            <div
              className={`tabs__pane -tab-item-1 ${
                activeTab === "All" ? "is-tab-el-active" : ""
              }`}
            >
              {bookingData?.length < 1 ? (
                loading ? (
                  <div className="mt-50 h-20vh relative">
                    <DivLoader />
                  </div>
                ) : (
                  <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
                    <div className="col-auto">
                      <h1 className="text-20 text-primary lh-14 fw-600">
                        No Bookings on Your Calendar Yet?
                      </h1>
                      <p className="text-13 fw-500">
                        There are so many amazing marathons waiting for you!
                        Dive in and find your next adventure today!
                      </p>
                    </div>
                    <div className="col-auto"></div>
                  </div>
                )
              ) : (
                <div className="table-container booking-table table-responsive col-12 overflow-scroll">
                  {/* scroll-bar-1 */}
                  <table className="table-3 col-12 -border-bottom text-12 fw-500 w-1200">
                    <thead className="font-inter bg-light-2">
                      <tr className="col-12">
                        <th scope="col">Event Name</th>
                        <th scope="col">Booking Date</th>
                        <th scope="col">Event Date</th>
                        <th scope="col">Race Distance</th>
                        <th scope="col">Status</th>
                        <th scope="col">Price</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookingData.map((event) => {
                        const encryptedParam = encryptData(event?.Booking_Id);
                        const encryptedParamEventId = encryptData(
                          event?.Event_Id
                        );
                        var arraytypevent =
                          event.Event_Category_List?.split(",");
                        return (
                          <tr className="items-center" key={event.Booking_Id}>
                            <td className="booking-underline items-center p-0">
                              <Link
                                component="button"
                                underline="none"
                                style={{
                                  color: "#000",
                                  textDecorationColor: "#000",
                                }}
                                onClick={() =>
                                  navigateToEvent(
                                    encryptedParamEventId,
                                    event.Display_Name
                                  )
                                }
                              >
                                <td
                                  className="text-13"
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  {event.Display_Name}
                                </td>
                              </Link>
                            </td>
                            {/* <td>{event.Display_Name}</td> */}
                            <td className="font-inter text-primary pt-20 items-center">
                              {event.Booking_Date}
                            </td>
                            <td className="font-inter text-primary pt-20 items-center">
                              {event.Start_Date}
                            </td>
                            <td className="pt-20">
                              <div className="d-flex items-center">
                                {arraytypevent?.map((datatype, index) => {
                                  if (index > 1) {
                                    return;
                                  }
                                  return (
                                    <div
                                      className="bg-light-2 font-inter rounded-16 fw-500 text-dark-1 py-5 px-15 lh-1 mr-10"
                                      key={`ML${datatype}`}
                                    >
                                      {datatype}
                                    </div>
                                  );
                                })}
                                {arraytypevent?.length > 2 ? (
                                  <div className="text-10 fw-500 text-light underline">
                                    +1
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                            <td className="pr-20 pl-0 pt-20">
                              {event.Booking_Status === "Pending" ? (
                                <span
                                  className="rounded-100 font-inter py-4 px-10 text-center fw-500"
                                  style={{ background: "#FF8E8E" }}
                                >
                                  {event.Booking_Status}
                                </span>
                              ) : event.Booking_Status === "Upcoming" ? (
                                <span
                                  className="rounded-100 font-inter py-4 px-10 text-center fw-500"
                                  style={{ background: "#FFF389" }}
                                >
                                  {event.Booking_Status}
                                </span>
                              ) : event.Booking_Status === "Complete" ? (
                                <span
                                  className="rounded-16 font-inter py-4 px-15 lh-1 fw-500"
                                  style={{ background: "#B8FF9B" }}
                                >
                                  {event.Booking_Status}
                                </span>
                              ) : event.Booking_Status === "Payment Pending" ||
                                event.Booking_Status === "Payment Failed" ? (
                                <span
                                  className="rounded-16 font-inter py-4 px-15 lh-1 fw-500"
                                  style={{ background: "#FF8E8E" }}
                                >
                                  {event.Booking_Status}
                                </span>
                              ) : null}
                            </td>
                            <td className="fw-700 text-16 items-center">
                              <span className="text-12 fw-500 text-light-1 mr-4">
                                ₹
                              </span>
                              <span className="font-inter text-20">
                                {event?.Net_Amount}
                              </span>
                            </td>
                            <td className="pt-10 pl-0">
                              <div className="dropdown js-dropdown js-actions-1-active">
                                {event.Booking_Status !== "Pending" &&
                                event.Booking_Status !== "Payment Pending" &&
                                event.Booking_Status !== "Payment Failed" ? (
                                  <>
                                    <div
                                      className="dropdown__button d-flex items-center rounded-4 text-primary text-14 px-15 py-5"
                                      // data-el-toggle=".js-actions-1-toggle"
                                      // data-el-toggle-active=".js-actions-1-active"
                                    >
                                      <LightTooltip
                                        title="View"
                                        placement="top"
                                        arrow
                                        slotProps={{
                                          popper: {
                                            modifiers: [
                                              {
                                                name: "offset",
                                              },
                                            ],
                                          },
                                        }}
                                        enterTouchDelay={20}
                                      >
                                        <i
                                          onClick={() =>
                                            navigate(
                                              `/view-ticket/${encryptedParam}`
                                            )
                                          }
                                          className="fas fa-eye text-15"
                                        ></i>
                                      </LightTooltip>
                                      <LightTooltip
                                        title="Download"
                                        placement="top"
                                        arrow
                                        slotProps={{
                                          popper: {
                                            modifiers: [
                                              {
                                                name: "offset",
                                              },
                                            ],
                                          },
                                        }}
                                        enterTouchDelay={20}
                                      >
                                        <i
                                          onClick={() =>
                                            downloadInvoice(event.Booking_Id)
                                          }
                                          className="fas fa-download text-15 ml-20"
                                        ></i>
                                      </LightTooltip>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="dropdown__button d-flex items-center rounded-4 text-primary text-14 px-15 py-5">
                                      <LightTooltip
                                        title="Pay Now"
                                        placement="top"
                                        arrow
                                        slotProps={{
                                          popper: {
                                            modifiers: [
                                              {
                                                name: "offset",
                                              },
                                            ],
                                          },
                                        }}
                                        enterTouchDelay={20}
                                      >
                                        <i
                                          // onClick={() =>
                                          //   navigate(
                                          //     `/view-ticket/${encryptedParam}`
                                          //   )
                                          // }
                                          className="fas fa-money-bill text-15"
                                        ></i>
                                      </LightTooltip>
                                    </div>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div
              className={`tabs__pane -tab-item-2 ${
                activeTab === "Upcoming" ? "is-tab-el-active" : ""
              }`}
            >
              {bookingData?.length < 1 ? (
                loading ? (
                  <div className="mt-50 h-20vh relative">
                    <DivLoader />
                  </div>
                ) : (
                  <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
                    <div className="col-auto">
                      <h1 className="text-20 text-primary lh-14 fw-600">
                        No Upcoming Bookings on Your Calendar Yet?
                      </h1>
                      <p className="text-13 fw-500">
                        There are so many amazing marathons waiting for you!
                        Dive in and find your next adventure today!
                      </p>
                    </div>
                    <div className="col-auto"></div>
                  </div>
                )
              ) : (
                <div className="overflow-scroll booking-table">
                  {/* scroll-bar-1 */}
                  <table className="table-3 -border-bottom col-12 text-12 fw-500 w-1200">
                    <thead className="bg-light-2">
                      <tr>
                        <th>Event Name</th>
                        <th>Event Date</th>
                        <th>Race Distance</th>
                        <th>Status</th>
                        <th>Price</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookingData.map((event) => {
                        const encryptedParam = encryptData(event?.Booking_Id);
                        const encryptedParamEventId = encryptData(
                          event?.Event_Id
                        );
                        var arraytypevent =
                          event.Event_Category_List?.split(",");

                        return (
                          <tr key={event.Booking_Id}>
                            <Link
                              component="button"
                              underline="none"
                              style={{
                                color: "#000",
                                textDecorationColor: "#000",
                              }}
                              onClick={() =>
                                navigateToEvent(
                                  encryptedParamEventId,
                                  event.Display_Name
                                )
                              }
                            >
                              <td className="text-13">{event.Display_Name}</td>
                            </Link>
                            <td className="text-primary pt-20 font-inter">
                              {event.Start_Date}
                            </td>
                            <td className="w-155 pt-20">
                              <div className="d-flex items-center">
                                {arraytypevent?.map((datatype, index) => {
                                  if (index > 1) {
                                    return;
                                  }
                                  return (
                                    <div
                                      className="bg-light-2 font-inter rounded-16 fw-500 text-dark-1 py-5 px-15 lh-1 ml-4"
                                      key={`ML${datatype}`}
                                    >
                                      {datatype}
                                    </div>
                                  );
                                })}
                                {arraytypevent?.length > 2 ? (
                                  <div className="text-10 fw-500 text-light underline">
                                    +1
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                            <td className="pr-20 pl-0 pt-20">
                              <span
                                className="rounded-100 font-inter py-4 px-10 text-center fw-500"
                                style={{ background: "#FFF389" }}
                              >
                                Upcoming
                              </span>
                            </td>
                            <td className="fw-700 text-16">
                              <span className="text-12 font-inter fw-500 text-light-1 mr-4">
                                ₹
                              </span>
                              <span className="font-inter text-20">
                                {event?.Net_Amount}
                              </span>
                            </td>
                            <td className="pt-10 pl-0">
                              <div className="dropdown js-dropdown js-actions-1-active">
                                <div
                                  className="dropdown__button d-flex items-center rounded-4 text-primary text-14 px-15 py-5"
                                  data-el-toggle=".js-actions-1-toggle"
                                  data-el-toggle-active=".js-actions-1-active"
                                >
                                  <i
                                    onClick={() =>
                                      navigate(`/view-ticket/${encryptedParam}`)
                                    }
                                    className="fas fa-eye text-15"
                                  ></i>
                                  <i
                                    onClick={() =>
                                      downloadInvoice(event.Booking_Id)
                                    }
                                    className="fas fa-download text-15 ml-20"
                                  ></i>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div
              className={`tabs__pane -tab-item-2 ${
                activeTab === "Pending" ? "is-tab-el-active" : ""
              }`}
            >
              {bookingData?.length < 1 ? (
                loading ? (
                  <div className="mt-50 h-20vh relative">
                    <DivLoader />
                  </div>
                ) : (
                  <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
                    <div className="col-auto">
                      <h1 className="text-20 text-primary lh-14 fw-600">
                        No Bookings on Your Calendar Yet?
                      </h1>
                      <p className="text-13 fw-500">
                        There are so many amazing marathons waiting for you!
                        Dive in and find your next adventure today!
                      </p>
                    </div>
                    <div className="col-auto"></div>
                  </div>
                )
              ) : (
                <div className="overflow-scroll booking-table">
                  {/* scroll-bar-1 */}
                  <table className="table-3 font-inter -border-bottom col-12 text-12 fw-500 w-1200">
                    <thead className="bg-light-2">
                      <tr>
                        <th>Event Name</th>
                        <th>Event Date</th>
                        <th>Race Distance</th>
                        <th>Status</th>
                        <th>Price</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookingData.map((event) => {
                        // const encryptedParam = encryptData(event?.Booking_Id);
                        const encryptedParamEventId = encryptData(
                          event?.Event_Id
                        );
                        var arraytypevent =
                          event.Event_Category_List?.split(",");
                        return (
                          <tr key={event.Booking_Id}>
                            {/* <Link
                              component="button"
                              underline="none"
                              style={{
                                color: "#000",
                                textDecorationColor: "#000",
                              }}
                              onClick={() =>
                                navigateToEvent(encryptedParamEventId)
                              }
                            > */}
                            <Link
                              component="button"
                              underline="none"
                              style={{
                                color: "#000",
                                textDecorationColor: "#000",
                              }}
                              onClick={() =>
                                navigateToEvent(
                                  encryptedParamEventId,
                                  event.Display_Name
                                )
                              }
                            >
                              <td className="text-13">{event.Display_Name}</td>
                            </Link>
                            {/* </Link> */}
                            <td className="text-primary pt-20 font-inter">
                              {event.Start_Date}
                            </td>
                            <td className="w-155 pt-20">
                              {" "}
                              <div className="d-flex items-center">
                                {arraytypevent?.map((datatype, index) => {
                                  if (index > 1) {
                                    return;
                                  }
                                  return (
                                    <div
                                      className="bg-light-2 font-inter rounded-16 fw-500 text-dark-1 py-5 px-15 lh-1 ml-4"
                                      key={`ML${datatype}`}
                                    >
                                      {datatype}
                                    </div>
                                  );
                                })}
                                {arraytypevent?.length > 2 ? (
                                  <div className="text-10 fw-500 text-light underline">
                                    +1
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                            <td className="pr-20 pl-0 pt-20">
                              <span
                                className="rounded-100 font-inter py-4 px-10 text-center fw-500"
                                style={{ background: "#FF8E8E" }}
                              >
                                {event?.Booking_Status}
                              </span>
                            </td>
                            <td className="fw-700 font-inter text-16">
                              <span className="text-12 fw-500 text-light-1 mr-4">
                                ₹
                              </span>
                              <span className="font-inter text-20">
                                {event?.Net_Amount}
                              </span>
                            </td>
                            <td>
                              <div className="dropdown js-dropdown js-actions-1-active">
                                <>
                                  <div className="dropdown__button d-flex items-center rounded-4 text-primary text-14 px-15 py-5">
                                    <LightTooltip
                                      title="Pay Now"
                                      placement="top"
                                      arrow
                                      slotProps={{
                                        popper: {
                                          modifiers: [
                                            {
                                              name: "offset",
                                            },
                                          ],
                                        },
                                      }}
                                      enterTouchDelay={20}
                                    >
                                      <i
                                        // onClick={() =>
                                        //   navigate(
                                        //     `/view-ticket/${encryptedParam}`
                                        //   )
                                        // }
                                        className="fas fa-money-bill text-15"
                                      ></i>
                                    </LightTooltip>
                                  </div>
                                </>
                                {/* <div
                                  className="dropdown__button d-flex items-center rounded-4 text-primary bg-blue-1-05 text-14 px-15 py-5"
                                  data-el-toggle=".js-actions-1-toggle"
                                  data-el-toggle-active=".js-actions-1-active"
                                >
                                  <i
                                    onClick={() =>
                                      navigate(
                                        `/dashboard/view-ticket/${encryptedParam}`
                                      )
                                    }
                                    className="fas fa-eye text-15"
                                  ></i>
                                  <i className="fas fa-download text-15 ml-20"></i>
                                </div> */}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div
              className={`tabs__pane -tab-item-1 ${
                activeTab === "Completed" ? "is-tab-el-active" : ""
              }`}
            >
              {bookingData?.length < 1 ? (
                loading ? (
                  <div className="mt-50 h-20vh relative">
                    <DivLoader />
                  </div>
                ) : (
                  <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
                    <div className="col-auto">
                      <h1 className="text-20 text-primary lh-14 fw-600">
                        No Bookings on Your Calendar Yet?
                      </h1>
                      <p className="text-13 fw-500">
                        There are so many amazing marathons waiting for you!
                        Dive in and find your next adventure today!
                      </p>
                    </div>
                    <div className="col-auto"></div>
                  </div>
                )
              ) : (
                <div className="overflow-scroll booking-table">
                  <table className="table-3 font-inter -border-bottom col-12 text-12 fw-500 w-1200">
                    <thead className="bg-light-2">
                      <tr>
                        <th>Event Name</th>
                        <th>Event Date</th>
                        <th>Race Distance</th>
                        <th>Status</th>
                        <th>Price</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookingData.map((event) => {
                        const encryptedParam = encryptData(event?.Booking_Id);
                        const encryptedParamEventId = encryptData(
                          event?.Event_Id
                        );
                        var arraytypevent =
                          event.Event_Category_List?.split(",");

                        return (
                          <tr key={event.Booking_Id}>
                            <Link
                              component="button"
                              underline="none"
                              style={{
                                color: "#000",
                                textDecorationColor: "#000",
                              }}
                              onClick={() =>
                                navigateToEvent(
                                  encryptedParamEventId,
                                  event.Display_Name
                                )
                              }
                            >
                              <td className="text-13">{event.Display_Name}</td>
                            </Link>
                            <td className="text-primary pt-20 font-inter">
                              {event.Start_Date}
                            </td>
                            <td className="w-155 pt-20">
                              {" "}
                              <div className="d-flex items-center">
                                {arraytypevent?.map((datatype, index) => {
                                  if (index > 1) {
                                    return;
                                  }
                                  return (
                                    <div
                                      className="bg-light-2 font-inter rounded-16 fw-500 text-dark-1 py-5 px-15 lh-1 m-1"
                                      key={`ML${datatype}`}
                                    >
                                      {datatype}
                                    </div>
                                  );
                                })}
                                {arraytypevent?.length > 2 ? (
                                  <div className="text-10 fw-500 text-light underline">
                                    +1
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                            <td className="pr-20 pl-0 pt-20">
                              <span
                                className="rounded-100 py-4 px-10 text-center fw-500"
                                style={{ background: "#B8FF9B" }}
                              >
                                Completed
                              </span>
                            </td>
                            <td className="fw-700 text-16">
                              <span className="text-12 font-inter fw-500 text-light-1 mr-4">
                                ₹
                              </span>
                              <span className="font-inter text-20">
                                {event?.Net_Amount}
                              </span>
                            </td>
                            <td className="pt-10 pl-0">
                              <div className="dropdown js-dropdown js-actions-1-active">
                                <div
                                  className="dropdown__button d-flex items-center rounded-4 text-primary text-14 px-15 py-5"
                                  data-el-toggle=".js-actions-1-toggle"
                                  data-el-toggle-active=".js-actions-1-active"
                                >
                                  <i
                                    onClick={() =>
                                      navigate(`/view-ticket/${encryptedParam}`)
                                    }
                                    className="fas fa-eye text-15"
                                  ></i>
                                  <i
                                    onClick={() =>
                                      downloadInvoice(event.Booking_Id)
                                    }
                                    className="fas fa-download text-15 ml-20"
                                  ></i>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            {/* <div className="tabs__pane -tab-item-5 ">
              {bookingData?.length < 1 ? (
                <div className="px-30 rounded-4 bg-white shadow-2">
                  <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
                    <div className="col-auto">
                      <h1 className="text-20 text-primary lh-14 fw-600">
                        No Bookings on Your Calendar Yet?
                      </h1>
                      <p className="text-13 fw-500">
                        There are so many amazing marathons waiting for you!
                        Dive in and find your next adventure today!
                      </p>
                    </div>
                    <div className="col-auto"></div>
                  </div>
                </div>
              ) : (
                <div className="overflow-scroll scroll-bar-1">
                  <table className="table-3 -border-bottom col-12 text-12 fw-500">
                    <thead className="bg-light-2">
                      <tr>
                        <th>Title</th>
                        <th>Event Date</th>
                        <th>Category</th>
                        <th>Status</th>
                        <th>Price</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookingData.map((event) => (
                        <tr key={event.Booking_Id}>
                          <td>{event.Display_Name}</td>
                          <td className="text-primary">
                            {new Date(event.Start_Date).toLocaleDateString()}
                          </td>
                          <td className="w-150">
                            {" "}
                            <span className="rounded-100 py-4 px-10 text-center fw-500 bg-yellow-1">
                              {event.EventType_Name}
                            </span>
                          </td>
                          <td>
                            <span
                              className="rounded-100 py-4 px-10 text-center fw-500"
                              style={{ background: "lightgray" }}
                            >
                              Cancelled
                            </span>
                          </td>
                          <td className="fw-600 text-14">
                            ₹{event.Net_Amount}
                          </td>
                          <td>
                            <div className="dropdown js-dropdown js-actions-1-active">
                              <div
                                className="dropdown__button d-flex items-center rounded-4 text-primary bg-blue-1-05 text-14 px-15 py-5"
                                data-el-toggle=".js-actions-1-toggle"
                                data-el-toggle-active=".js-actions-1-active"
                              >
                                <i className="fas fa-eye text-15"></i>
                                <i className="fas fa-download text-15 ml-20"></i>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Booking;

// const downloadInvoice = async (booking_id) => {
//   const reqdata = {
//     Org_Id: user?.Org_Id,
//     Session_User_Id: user?.Participant_Id,
//     Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
//   };

//   try {
//     const result = await RestfullApiServiceGet(
//       reqdata,
//       `participant/downloadinvoicebase?Booking_Id=${booking_id}`
//     );

//     console.log(result?.data);
//     debugger;
//     if (result) {
//       const decodedResult = atob(result);

//       // Convert decoded result to Uint8Array
//       const arrayBuffer = new Uint8Array(decodedResult.length);
//       for (let i = 0; i < decodedResult.length; i++) {
//         arrayBuffer[i] = decodedResult.charCodeAt(i);
//       }

//       // Create Blob from Uint8Array
//       const blob = new Blob([arrayBuffer], { type: "application/pdf" });

//       // Create URL for the Blob
//       const url = window.URL.createObjectURL(blob);

//       // Create a link element, set the href and download attributes
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "invoice.pdf");

//       // Append the link to the DOM and trigger the download
//       document.body.appendChild(link);
//       link.click();

//       // Clean up: remove the link from the DOM
//       document.body.removeChild(link);

//       // Optionally, handle success messages
//       toast.success("Invoice downloaded successfully!");
//     }
//   } catch (err) {
//     // Handle errors if the API call fails
//     toast.error("Failed to download invoice. Please try again later.");
//     console.error("Error downloading invoice:", err);
//   }
// };

// const downloadInvoice = async (booking_id) => {
//   const reqdata = {
//     Org_Id: user?.Org_Id,
//     Session_User_Id: user?.Participant_Id,
//     Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
//   };

//   try {
//     const response = await RestfullApiServiceGet(
//       reqdata,
//       `participant/downloadinvoice?Booking_Id=${booking_id}`
//     );

//     if (response) {
//       // Assuming the API returns a blob (PDF content) or a URL to download
//       // const blob = new Blob([result]); // Create a Blob object from API response
//       // const url = window.URL.createObjectURL(blob); // Create a URL to the blob
//       // const link = document.createElement("a"); // Create a <a> element
//       // link.href = url; // Set the href attribute of the <a> to the URL
//       // link.setAttribute("download", "invoice.pdf"); // Set the download attribute
//       // document.body.appendChild(link); // Append the <a> element to the DOM
//       // link.click(); // Simulate a click on the <a> element to trigger download
//       // document.body.removeChild(link); // Clean up: remove the <a> element

//       // // Optionally, you can handle success messages or actions after download
//       // toast.success("Invoice downloaded successfully!");
//       // Assuming the API returns the PDF content directly
//       const pdfContent = response.data; // Adjust this based on your API response structure

//       // Decode base64 content if necessary
//       const decodedPdfContent = atob(pdfContent);

//       // Create a Blob object from decoded content
//       const blob = new Blob([decodedPdfContent], { type: "application/pdf" });

//       // Create a URL to the blob
//       const url = window.URL.createObjectURL(blob);

//       // Create a <a> element
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "invoice.pdf");

//       // Append the <a> element to the DOM
//       document.body.appendChild(link);

//       // Simulate a click on the <a> element to trigger download
//       link.click();

//       // Clean up: remove the <a> element from the DOM
//       document.body.removeChild(link);

//       // Optionally, you can handle success messages or actions after download
//       toast.success("Invoice downloaded successfully!");
//     }
//   } catch (err) {
//     // Handle errors if the API call fails
//     toast.error("Failed to download invoice. Please try again later.");
//     console.error("Error downloading invoice:", err);
//   }
// };
